/**
 * Reserved internal sentinel for the visual-only "All" option shown only when the
 * tenant has no real assignee options. It is namespaced so it cannot collide with a
 * real backend "assigned_to" value (those are user-entered names): selecting "All"
 * sends no assignee — buildCreateWorkTaskPayload maps it (like an empty selection) to
 * null. The user-facing label is the translated "All", never this token.
 */
export const ASSIGNEE_ALL_VALUE = '__create_work_all_sentinel__';

export interface AssigneeOption {
  label: string;
  value: string;
}

/**
 * Build the assignee dropdown options from the tenant's assigned-to values. When
 * the tenant has none, fall back to a single visual "All" option.
 */
export function buildAssigneeOptions(values: string[], allLabel: string): AssigneeOption[] {
  if (values.length === 0) {
    return [{ label: allLabel, value: ASSIGNEE_ALL_VALUE }];
  }
  return values.map((value) => ({ label: value, value }));
}
